import { QuickGlanceOverlay, useContainerWidth } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import handwritingExamplesDesktop from './images/handwritingExamplesDesktop.png'
import handwritingExamplesTablet from './images/handwritingExamplesTablet.png'

export default function HandwritingOverlay(overlay) {
  const [t] = useTranslation()
  const atWidth = useContainerWidth()

  const imgProps = atWidth({
    default: { src: handwritingExamplesTablet, width: '100%' },
    xl: { src: handwritingExamplesDesktop, width: '100%' },
  })

  return (
    <QuickGlanceOverlay
      maxWidth="100vw"
      {...overlay}
      placement={['end', 'start', 'bottom']}
      title={t('task-viewer.handwriting-tooltip', 'Handwriting Examples')}
    >
      <img {...imgProps} alt={t('task-viewer.handwriting-alt-text', 'Table of handwriting examples for each letter')} />
    </QuickGlanceOverlay>
  )
}
